import type { Client } from '@sentry/core';
import {
  browserTracingIntegration,
  init,
  replayIntegration,
} from '@sentry/react';

import { ENVIRONMENT, SENTRY_DSN } from './injectedConstants.js';

let sentryClient: Client | undefined;

/**
 * Get sentry client
 */
export function getSentryClient(): Client | undefined {
  if (sentryClient == null && SENTRY_DSN != null) {
    sentryClient = init({
      dsn: SENTRY_DSN,
      environment: ENVIRONMENT,
      integrations: [browserTracingIntegration(), replayIntegration()],

      tracesSampleRate: 1,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  return sentryClient;
}
